import type { MakeInputProps } from '@frontend/forms';
import type { ClassName } from '@frontend/web-utils';
import type { CheckboxProps } from './Checkbox';
import { Checkbox } from './Checkbox';

type CheckboxInputProps = MakeInputProps<
  boolean,
  CheckboxProps,
  'children' | 'className' | 'label' | 'onChange' | 'value'
> & { className?: ClassName };

export const CheckboxInput = ({ value, ...props }: CheckboxInputProps) => <Checkbox checked={value} {...props} />;
